module.exports = __webpack_public_path__ + "img/expovina-primavera_02(1).ef24f55a.jpg";